export default function traductionMsgAvertissementBailleur(avertissements, messages) {
  avertissements.forEach((avertissement) => {
    if (avertissement.indexOf('BIC_LENGTH_8_OR_11') === 0) {
      messages.push({
        message: 'addEditBailleur.avertissement.bic.length',
      });
    }
    if (avertissement.indexOf('BIC_BRANCH_CODE_ONLY_LETTERS_OR_DIGITS') === 0) {
      messages.push({
        message: 'addEditBailleur.avertissement.bic.branchCodeOnlyLettersOrDigit',
      });
    }
    if (avertissement.indexOf('COUNTRY_CODE_UNSUPPORTED') === 0) {
      if (avertissement.indexOf('Bic') !== -1) {
        messages.push({
          message: 'addEditBailleur.avertissement.bic.countryCodeUnsupported',
        });
      } else {
        messages.push({
          message: 'addEditBailleur.avertissement.iban.countryCodeUnsupported',
        });
      }
    }
    if (avertissement.indexOf('BIC_GENERIC_ERROR') === 0) {
      const code = avertissement.split('@')[2].split('|')[0];
      messages.push({
        message: 'addEditBailleur.avertissement.bic.genericError',
        parametres: {
          code: code,
        },
      });
    }
    if (avertissement.indexOf('IBAN_BAD_LENGHT') === 0) {
      messages.push({
        message: 'addEditBailleur.avertissement.iban.length',
      });
    }
    if (avertissement.indexOf('COUNTRY_CODE_UPPER_CASE_LETTERS') === 0) {
      messages.push({
        message: 'addEditBailleur.avertissement.iban.countryCodeUpperCaseLetters',
      });
    }
    if (avertissement.indexOf('IBAN_GENERIC_ERROR') === 0) {
      const code = avertissement.split('@')[2];
      messages.push({
        message: 'addEditBailleur.avertissement.iban.genericError',
        parametres: {
          code: code,
        },
      });
    }
    if (avertissement.indexOf('IBAN_INVALID_CHECK_DIGIT_VALUE') === 0) {
      messages.push({
        message: 'addEditBailleur.avertissement.iban.invalidCheckDigitValue',
      });
    }
  });
}
